export const ADD_ITEM = "ADD_ITEM";
export const MERGE_ITEM = "MERGE_ITEM";
export const REMOVE_ITEM = "REMOVE_ITEM";
export const ADD_ITEMS = "ADD_ITEMS";
export const SET_ITEMS = "SET_ITEMS";
export const SET_CART_NOTE = "SET_CART_NOTE";
export const SET_PRODUCT_ID = "SET_PRODUCT_ID";
export const SET_CAMPAIGN = "SET_CAMPAIGN";
export const ADD_UPSELL = "ADD_UPSELL";
export const REMOVE_UPSELL = "REMOVE_UPSELL";

const fixItemPrice = (item) => {
  const { price, line_price, quantity, discounts } = item;
  if (!discounts?.length && line_price > 0 && price * quantity !== line_price) {
    item.price = line_price / quantity;
  }
  return item;
};

function getBagSelectors() {
  const initialSelectors = [
    ".icon_cart .tcount",
    ".sticky_nav .cart_count",
    "#header .cart_count",
    "[data-desktop-header] .cart_count",
    ".cart-count-bubble span",
    ".sticky_nav .header-right + div .cart-count",
    ".sticky_nav .header-right .cart-count",
    "#header .cart-count",
    "[data-desktop-header] .cart-count",
    "[data-cart-count]",
    "#shopify-section-toolbar_mobile [data-cart-count]",
    ".cart-icon--basket2 > div",
    "[aria-label='Cart'] > div",
    ".header__icon-list .header__cart-count",
    ".hidden-pocket .header__cart-count",
    "#nav-user #cart-count",
    "#nav #cart-count",
    ".mobile-header-wrap .cart-item-count-header",
    "#site-header .cart-item-count-header",
    ".count-bubble.count-bubble--md",
    ".page__header--desktop [data-count]",
    ".page__header--mobile [data-count]",
    "span.cartCount",
    "[data-js-cart-count]",
    ".header__row-mobile [data-js-cart-count]",
    "#navbar-desktop .cart-count-badge",
    "#navbar-mobile .cart-count-badge",
  ];
  return initialSelectors.concat(
    window.mu_bag_selecor || window.mu_bag_selector || []
  );
}

function updateBagCounter(item_count) {
  if (item_count) {
    const dawn_icon = document.querySelector("#cart-icon-bubble");
    const dawn_counter = document.querySelector(".cart-count-bubble span");
    const envy_counters = document.querySelectorAll(
      "span.cart-item-count-header:not(.show)"
    );
    if (dawn_icon && !dawn_counter) {
      const cart_svg = dawn_icon.querySelector(".icon.icon-cart-empty");
      if (cart_svg) {
        cart_svg.outerHTML = `<svg class="icon icon-cart" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"></path></svg>`;
        let cart_bubble = document.createElement("div");
        cart_bubble.setAttribute("class", "cart-count-bubble");
        cart_bubble.innerHTML = `<span aria-hidden="true">${item_count}</span><span class="visually-hidden">${item_count} items</span>`;
        dawn_icon.appendChild(cart_bubble);
      }
    }
    if (envy_counters.length) {
      envy_counters.forEach((envy_counter) => {
        envy_counter.classList.add("show");
        envy_counter.classList.remove("hide");
      });
    }
  }
  let selectors = getBagSelectors();
  selectors.forEach((selector) => {
    if (typeof selector === "function") {
      selector(item_count || 0);
    } else if (document.querySelectorAll(selector).length) {
      let counter = document.querySelectorAll(selector)[0];

      let child_nodes = counter.querySelectorAll("*");

      if (child_nodes.length) {
        counter = child_nodes[0];
      }
      counter.textContent = item_count || 0;
    }
  });
}

export const CartItemsReducer = (AppLocalStorage) => (state, action) => {
  switch (action.type) {
    case SET_ITEMS:
      const items = action.items.map(fixItemPrice);
      sendCartUpdatedEvent(items);
      return {
        ...state,
        items,
        cart_level_discount_applications:
          action.cart_level_discount_applications ||
          state.cart_level_discount_applications,
      };
    case SET_CART_NOTE:
      return { ...state, cartNote: action.cartNote };
    case ADD_ITEM:
      const new_items = [action.item].concat(state.items).map(fixItemPrice);
      sendCartUpdatedEvent(new_items);
      return { ...state, items: new_items };
    case MERGE_ITEM:
      const item_exists = state.items.find(({ id }) => id === action.item.id);
      if (!item_exists) {
        const items = [action.item].concat(state.items).map(fixItemPrice);
        sendCartUpdatedEvent(items);
        return { ...state, items };
      } else {
        const items = state.items.map((item) => {
          if (item.id === action.item.id) {
            return action.item;
          }
          return item;
        });
        sendCartUpdatedEvent(items);
        return { ...state, items };
      }
    case REMOVE_ITEM:
      const filtered_items = state.items.filter(({ id }) => id !== action.id);
      sendCartUpdatedEvent(filtered_items);
      return { ...state, items: filtered_items };
    case ADD_ITEMS:
      const added_items = action.item.concat(state.items).map(fixItemPrice);
      sendCartUpdatedEvent(added_items);
      return { ...state, items: added_items };
    case SET_PRODUCT_ID:
      return { ...state, product_id: action.product_id };
    case SET_CAMPAIGN:
      return { ...state, campaign: action.campaign };
    case ADD_UPSELL:
      const newUpsells = [...new Set([...state.fbtUpsells, action.id])];
      AppLocalStorage.setItem("monster_uc_upsells", JSON.stringify(newUpsells));
      return { ...state, fbtUpsells: newUpsells };
    case REMOVE_UPSELL:
      const finalUpsells = state.fbtUpsells.filter(
        (variant_id) => variant_id !== action.id
      );
      AppLocalStorage.setItem(
        "monster_uc_upsells",
        JSON.stringify(finalUpsells)
      );
      return { ...state, fbtUpsells: finalUpsells };
    default:
      return state;
  }
};

function sendCartUpdatedEvent(items) {
  const counter = items.reduce((total, item) => total + item.quantity, 0);
  updateBagCounter(counter);
  if (window.mu_stop_cart_updated_event) return;
  const event = new CustomEvent("cart:updated", { detail: { items } });
  document.dispatchEvent(event);
}
